import { Redirect } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import useStore from '../hooks/useStore';

const Logout = () => {
  const { resetStoreState } = useStore();
  const logoutUser = async () => {
    await resetStoreState()
    Auth.signOut();
    localStorage.clear();
  }

  logoutUser();
  return <Redirect to={{ pathname: '/' }} />;
};
export default Logout;
